import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IPenthouseTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const PenthouseTagItem = ({ onDeleteClick, withNewTag }: IPenthouseTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Пентхаус
    </TagComponent>
  );
};
